class Bf2026TeaserMenu extends HTMLElement {
  connectedCallback() {
    this.root = this.closest('.bf26');
    if (!this.root || this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.links = [...this.querySelectorAll('.nav_link')];
    this.header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('.local-header');
    this.frame = 0;
    this.schedule = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    };
    this.addEventListener('click', (event) => this.navigate(event), { signal });
    window.addEventListener('scroll', this.schedule, { passive: true, signal });
    window.addEventListener('resize', this.schedule, { signal });
    if (this.header) {
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.header);
      const headerSection = this.header.closest('.section-header') || this.header;
      headerSection.addEventListener('transitionend', this.schedule, { signal });
    }
    this.update();
  }

  get mobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  get headerBottom() {
    if (!this.header) return 0;
    // The sticky header may be translated offscreen while scrolling down.
    return Math.max(0, this.header.getBoundingClientRect().bottom);
  }

  update() {
    const bottom = this.headerBottom;
    this.root.style.setProperty('--bf26-header-bottom', `${bottom}px`);
    let active = '#bf26-top';
    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const threshold = this.mobile ? Math.max(bottom, headerHeight) + this.offsetHeight + 16 : 200;
    this.links.forEach((link) => {
      const target = this.root.querySelector(link.hash);
      if (target && target.getBoundingClientRect().top <= threshold) active = link.hash;
    });
    this.links.forEach((link) => {
      const selected = link.hash === active;
      link.classList.toggle('active', selected);
      if (selected) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  }

  navigate(event) {
    const link = event.target.closest('.nav_link');
    if (!link || !this.contains(link)) return;
    const target = this.root.querySelector(link.hash);
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    // Account for the header reappearing during upward smooth scrolling.
    const headerHeight = this.header ? this.header.offsetHeight : 0;
    const offset = this.mobile ? Math.max(this.headerBottom, headerHeight) + this.offsetHeight + 8 : Math.max(this.headerBottom, headerHeight) + 8;
    window.scrollTo({
      top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }
}

if (!customElements.get('bf2026-teaser-menu')) {
  customElements.define('bf2026-teaser-menu', Bf2026TeaserMenu);
}
